import React, {useEffect, useState, useCallback, useMemo, useRef} from 'react';
import {useQuery} from 'react-query';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {useTranslation} from 'react-i18next';
// @ts-ignore
import Vudio from 'vudio';
// import AudioPlayer, {RHAP_UI} from 'react-h5-audio-player';
// import fetch from 'node-fetch';
// import 'react-h5-audio-player/lib/styles.css';
// import WaveSurfer from 'wavesurfer.js';
import './app.css';
// @ts-ignore
import avatar from './assets/images/media-octagon.png';
// @ts-ignore
import inclusive from './assets/images/all_inclusive.png';
// @ts-ignore
import media_play from './assets/images/media-play.png';
// @ts-ignore
import media_pause from './assets/images/media-pause.png';
// @ts-ignore
import backward_seconds from './assets/images/backward-15-seconds.svg';
// @ts-ignore
import forward_seconds from './assets/images/forward-15-seconds.svg';
// @ts-ignore
import volume_high from './assets/images/volume-high.svg';
// @ts-ignore
import volume_slash from './assets/images/volume-slash.svg';

import {
	Box,
	Tab,
	Tabs,
	Button,
	Divider,
	List,
	ListItem,
	ListItemAvatar,
	ListItemButton,
	ListItemText,
	Skeleton,
	Typography,
	Avatar,
	Container, useTheme, CircularProgress, Stack
} from '@mui/material';

import PlayIcon from '@icons/PlayIcon';
import PauseIcon from '@icons/PauseIcon';
// import WaveSurferPlayer from './components/WaveSurferPlayer';
// import WavePlayer from './components/WavePlayer';
// import useCountRender from '@hooks/useCountRender';
// import AudioPlayer, {RHAP_UI} from 'react-h5-audio-player';
import {appConfig} from '@config';

type TStation = {
	'id': number,
	'name': string,
	'logo': string,
	'audio': string,
	'category': string,
	'tag': string,
	'isLocal': boolean,
	'isStream': boolean,
	'isHomePage': boolean
};
const serverUrl = appConfig.radio.url;

function getTag(type: string) {
	let tags = {
		'stream': 'bg-green-300 text-black',
		'live': 'bg-blue-500 text-white',
		'shahadat': 'bg-black text-white',
		'default': 'bg-white text-black'
	};
	// @ts-ignore
	return tags[type] || tags['default'];
}

const fetchStations = async () => {
	const res = await fetch(`${serverUrl}/stations`);
	return res.json();
};

function AudioDuration() {
	return (
		<div><img src={inclusive}/></div>
	);
}

function TabsComponent(props: { stationFilterKey: any; handleTabChange: any; stations: any; }) {
	const {stationFilterKey, handleTabChange, stations} = props;
	const {t} = useTranslation();
	return (
		<Box sx={{borderBottom: 1, borderColor: 'divider'}}>
			<Tabs
				value={stationFilterKey}
				onChange={handleTabChange}
				textColor="secondary"
				indicatorColor="secondary"
				aria-label="secondary tabs example"
				variant="fullWidth"
			>
				<Tab value={'all'} label={t('radio.all')}/>
				{
					Object.keys(stations).map((station, index) => {
						return (
							<Tab key={index} value={station} label={t(`radio.${station}`)}/>
						);
					})
				}
			</Tabs>
		</Box>
	);
}

const Radio = () => {
	const {t} = useTranslation();
	const theme = useTheme();
	// useCountRender();
	const [stations, setStations] = useState<{ [key: string]: TStation[] }>({});
	const refAudio = useRef<HTMLAudioElement>(null);
	const refCanvas = useRef<HTMLCanvasElement>(null);
	const [audio, setAudio] = useState(null);
	const [canvas, setCanvas] = useState(null);
	const [vudio, setVudio] = useState(null);
	const [isPlaying, setIsPlaying] = useState(false);
	const [isMute, setIsMute] = useState(false);
	const [audioContext, setAudioContext] = useState();
	const [isRadioLoaded, setIsRadioLoaded] = useState(false);
	
	const handleStations = (newStations: any) => {
		setStations(() => newStations);
	};
	const {
		data,
		isFetching,
		isLoading,
		isSuccess,
		status,
		error
	} = useQuery('radio_stations', fetchStations, {onSuccess: handleStations});
	const [stationFilter, setStationFilter] = useState<TStation[]>([]);
	const [stationFilterKey, setStationFilterKey] = useState('all');
	const [stationPlayer, setStationPlayer] = useState<TStation>();
	const [stationPlayerAudio, setStationPlayerAudio] = useState<string>('');
	const handleTabChange = useMemo(() => (event: React.SyntheticEvent, newValue: string) => {
		setStationFilterKey(() => newValue);
		onStationFilter(newValue);
	}, [stationFilterKey]);
	
	const clickStation = useCallback((station: any) => {
		// console.log(window.AudioContext);
		setIsPlaying(false);
		setStationPlayer(station);
		if (['all', 'archive'].includes(stationFilterKey) && station?.isLocal) {
			setStationPlayerAudio(() => `${serverUrl}/media/sounds/${station?.audio}`);
		} else {
			setStationPlayerAudio(() => station!.audio);
		}
	}, []);
	
	const onStationPlayerAudio = useCallback(() => {
		if (['all', 'archive'].includes(stationFilterKey) && stationPlayer?.isLocal) {
			setStationPlayerAudio(`${serverUrl}/media/sounds/${stationPlayer?.audio}`);
		} else {
			setStationPlayerAudio(stationPlayer!.audio);
		}
	}, []);
	
	const onActiveStation = useCallback(() => {
		if (Object.keys(stations).length > 0 && typeof stations.stream !== undefined) {
			let activeStation: TStation[] = Object.values(stations.stream).filter((station: TStation) => {
				return station.isHomePage;
			});
			setStationFilterKey(() => 'stream');
			clickStation(activeStation[0]);
		}
	}, []);
	
	const onStationFilter = useCallback((filterKey: string) => {
		let filteredStation: TStation[] = [];
		if (filterKey === 'all') {
			Object.keys(stations).map((station: string) => {
				filteredStation = [...filteredStation, ...stations[station]];
			});
		} else {
			filteredStation = stations[filterKey] ?? stations;
			// filteredStation = Object.values(stationsList).filter((station) => {
			// 	return station.category === stationFilter;
			// });
		}
		setStationFilter(() => filteredStation);
		// onStationPlayer();
	}, [stations]);
	
	useEffect(() => {
		if (Object.keys(stations).length > 0 && typeof stations.stream !== undefined) {
			let activeStation: TStation[] = Object.values(stations.stream).filter((station: TStation) => {
				return station.isHomePage;
			});
			setStationFilterKey(() => 'stream');
			onStationFilter('stream');
			clickStation(activeStation[0]);
		}
	}, [stations]);
	let audioSource: MediaElementAudioSourceNode;
	let analyser;
	let dataArray;
	useEffect(() => {
		const audioCtx = new AudioContext();
		// let audioObj = document.querySelector('#audio2');
		// let canvasObj = document.querySelector('#canvas2');
		const timer = setTimeout(() => {
			// let canvasObj = $('#canvas');
			// let audioObj = $('audio');
			let prettify = false;
			let audioObj = refAudio.current;
			let canvasObj = refCanvas.current;
			// @ts-ignore
			setAudio(audioObj);
			// @ts-ignore
			setCanvas(canvasObj);
			
			
			// dataArray = new Uint8Array(analyser.frequencyBinCount);
			if (typeof audioSource == undefined) {
				audioSource = audioCtx.createMediaElementSource(audioObj as HTMLMediaElement);
				analyser = audioCtx.createAnalyser();
				audioSource.connect(analyser);
				analyser.connect(audioCtx.destination);
				// @ts-ignore
				setAudioContext(audioCtx);
			}
			// audioObj.crossOrigin = 'anonymous';
			let colors = [
				[
					[0, '#f00'],
					[0.3, '#f00'],
					[0.3, '#f90'],
					[0.7, '#f90'],
					[0.7, '#ff0'],
					[1, '#ff0']
				],
				'#ff0',
				['#06f', '#09f', ' #0Cf', '#007aff'],
				['#fb6d6b', '#c10056', ' #a50053', '#51074b'],
				[
					[0, '#06f'],
					[0.5, '#06f'],
					[0.5, '#09f'],
					[1, '#09f']
				],
				[
					[1, 'rgba(48,192,132,0.8)'],
					[0.7, '#ff0'],
					[1, 'rgba(48,192,132,0.59)'],
					[0.7, '#f90'],
					[1, 'rgba(48,192,132,0.8)'],
					[1, '#ff0']
				]
			];
			// audioObj.current.crossOrigin = 'anonymous';
			let vudioObj = new Vudio(audioObj, canvasObj, {
				effect: 'waveform',
				accuracy: 128, // Accuracy, actually expressed as the number of waveform bars, range 16-16348, must be 2 to the Nth power
				// width: 250,
				height: 100,
				circlebar: {
					maxHeight: 40,
					fadeSide: true,
					particle: false,
					shadowBlur: 4,
					shadowColor: 'rgba(244,244,244,.5)'
					// coverImg: nuanchun
				},
				circlewave: {
					maxHeight: 20,
					minHeight: -5,
					width: 250,
					height: 100,
					spacing: 1,
					fadeSide: true,
					shadowBlur: 2,
					shadowColor: '#caa',
					// coverImg: `${serverUrl}/media/images/${stationPlayer?.logo}?${stationPlayer?.name}`,
					prettify: true,
					particle: true,
					maxParticle: 100,
					circleRadius: 50,
					showProgress: false
				},
				waveform: {
					maxHeight: 80,
					minHeight: 1,
					spacing: 1,
					shadowBlur: 0,
					shadowColor: 'rgba(7,85,228,0.93)',
					prettify: true,
					fadeSide: true,
					horizontalAlign: 'center',
					verticalAlign: 'middle',
					color: [
						[0, '#f00'],
						[0.3, '#f00'],
						[0.3, '#f90'],
						[0.7, '#f90'],
						[0.7, '#ff0'],
						[1, '#ff0']
					]
				},
				lighting: {
					lineWidth: 2,
					maxHeight: 140,
					maxSize: 8,
					dottify: true,
					fadeSide: true,
					prettify: true,
					// color: '#49f3f7',
					shadowBlur: 2,
					shadowColor: 'rgba(244,244,244,.5)',
					horizontalAlign: 'center',
					verticalAlign: 'middle',
					showProgress: true
				}
			});
			vudioObj.setOption({
				waveform: {
					color: colors[4],
					prettify: true
				},
				circlewave: {
					color: colors[2],
					prettify: true
				},
				circlebar: {
					color: [
						[1, 'rgba(48,192,132,0.8)'],
						[0.7, '#ff0'],
						[1, 'rgba(48,192,132,0.59)'],
						[0.7, '#f90'],
						[1, 'rgba(48,192,132,0.8)'],
						[1, '#ff0']
					],
					prettify: true
				},
				lighting: {
					color: colors[5]
				}
			});
			setVudio(vudioObj);
			// @ts-ignore
			// vudioObj.dance();
			// vudio.play();
			// @ts-ignore
			// audioObj.play();
			// vudio.dance();
			if (vudioObj) {
				// @ts-ignore
				vudioObj.dance();
			}
		}, 1000);
		return () => {
			clearTimeout(timer);
		};
		
	}, []);
	
	function myOnLoadedData() {
		setIsRadioLoaded(true);
	}
	
	function myOnProgress() {
	}
	
	// On play button click
	const onPlayClick = useCallback(() => {
		// if (vudio && audio) {
		if (isPlaying) {
			//@ts-ignore
			// vudio.pause();
			//@ts-ignore
			audio.pause();
		} else {
			//@ts-ignore
			vudio.dance();
			//@ts-ignore
			audio.play();
		}
		setIsPlaying(!isPlaying);
		// const ctx = new (window.AudioContext)();
		// const osc = ctx.createOscillator();
		// osc.connect(ctx.destination);
		// ctx.resume();
		// console.log(ctx);
		// @ts-ignore
		// audio.play();
		// @ts-ignore
		// vudio.dance();
		// }
	}, [audio, vudio, isPlaying]);
	
	// On mute button click
	const onMuteClick = useCallback(() => {
		if (isMute) {
			setIsMute(false);
			// @ts-ignore
			audio.volume = 1;
		} else {
			setIsMute(true);
			// @ts-ignore
			audio.volume = 0;
		}
		// setVolumeValue();
	}, [audio, isMute]);
	// On forward button click
	const onForwardClick = useCallback(() => {
		// @ts-ignore
	}, [audioContext]);
	// On backward button click
	const onBackwardClick = useCallback(() => {
	}, [audioContext]);
	return (
		<>
			{
				(!isLoading && isSuccess) ? (
					<div id="radio" className="w-full h-full flex flex-col space-y-2">
						<HeaderWithIcons title={t('radio.radio_razavi')}/>
						<div className="mx-4 grow">
							<Stack sx={{
								borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : theme.palette.grey[700],
								bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'background.paper'
							}} className={`${theme.palette.mode === 'light' ? 'bg-blue-200' : 'background.paper'}`}>
								<div className="flex flex-row rounded mb-2 pr-3 pt-3">
									{
										stationPlayer?.logo ? (
											<img id="bg"
											     src={`${serverUrl}/media/images/${stationPlayer?.logo}?${stationPlayer?.name}`}
											     className="w-16 h-16 rounded"
											     alt={stationPlayer?.name}
											/>
										) : null
									}
									<span className="w-full p-3 mt-3">{stationPlayer?.name ?? t('radio_text')}</span>
									{
										!isRadioLoaded ? (
											<div className={`flex w-full h-full justify-center items-center relative top-5`}>
												<CircularProgress color={'secondary'}/>
											</div>
										) : null
									}
								</div>
								<div className="rounded py-0 w-full px-2 mt-3 justify-center" style={{direction: 'ltr'}}>
									{
										<>
											<div className="justify-center items-center w-full px-2"><Divider className="bg-blue-200"/></div>
											<div className="w-full h-32">
												<audio
													ref={refAudio}
													src={stationPlayerAudio}
													preload="auto"
													crossOrigin="anonymous"
													onLoadedData={myOnLoadedData}
													onProgress={myOnProgress}
												></audio>
												<canvas ref={refCanvas} className="canvasWave"></canvas>
											</div>
											<div className="w-full flex flex-row">
												{
													isRadioLoaded ? (
														<>
															<div className="flex flex-[2] flex-row flex-wrap justify-end content-center items-center">
																<div>
																	<img src={backward_seconds} alt={'backward_seconds'} onClick={onBackwardClick}/>
																</div>
																<div onClick={onPlayClick}>
																	{isPlaying ? <img src={media_pause} alt={'media_pause'}/> :
																		<img src={media_play} alt={'media_play'}/>}
																</div>
																<div>
																	<img src={forward_seconds} alt={'forward_seconds'} onClick={onForwardClick}/>
																</div>
															</div>
															<div className="flex flex-1 justify-center self-center gap-2">
																{isMute ? <img src={volume_slash} alt={'media_pause'} onClick={onMuteClick}/> :
																	<img src={volume_high} alt={'media_play'} onClick={onMuteClick}/>}
																{/*<Slider defaultValue={0} min={0} max={1} step={0.1} aria-label="Default" valueLabelDisplay="auto"*/}
																{/*        valueLabelFormat={(value) => {*/}
																{/*	        return value * 100;*/}
																{/*        }}*/}
																{/*        value={volumeValue}*/}
																{/*        onChange={handleVolumeChange}/>*/}
															</div>
														</>
													) : null
												}
											</div>
											{/*<p>Seconds played: {currentTime}</p>*/}
										</>
									}
									{/*{*/}
									{/*	stationPlayer?.isStream ? (*/}
									{/*		<AudioPlayer*/}
									{/*			preload="metadata"*/}
									{/*			// ref={(e) => playerRef y= e}*/}
									{/*			// ref={playerRef}*/}
									{/*			className="player"*/}
									{/*			src={stationPlayerAudio}*/}
									{/*			showJumpControls={true}*/}
									{/*			showFilledProgress={true}*/}
									{/*			showDownloadProgress={true}*/}
									{/*			defaultCurrentTime={t('radio.loading')}*/}
									{/*			defaultDuration={<AudioDuration/>}*/}
									{/*			customIcons={{*/}
									{/*				play: <img src={media_play}/>,*/}
									{/*				pause: <img src={media_pause}/>,*/}
									{/*				rewind: <img src={backward_seconds}/>,*/}
									{/*				forward: <img src={forward_seconds}/>,*/}
									{/*				volume: <img src={volume_high}/>,*/}
									{/*				volumeMute: <img src={volume_slash}/>*/}
									{/*			}}*/}
									{/*			progressJumpSteps={*/}
									{/*				{backward: 15000, forward: 15000}*/}
									{/*			}*/}
									{/*			layout="stacked"*/}
									{/*			// customControlsSection={*/}
									{/*			// 	[*/}
									{/*			// 		<div className="w-4/5 relative top-2">*/}
									{/*			// 			<Divider className="bg-blue-400"/>*/}
									{/*			// 		</div>,*/}
									{/*			// 		RHAP_UI.ADDITIONAL_CONTROLS,*/}
									{/*			// 		RHAP_UI.MAIN_CONTROLS,*/}
									{/*			// 		RHAP_UI.VOLUME_CONTROLS*/}
									{/*			// 	]*/}
									{/*			// }*/}
									{/*			customProgressBarSection={*/}
									{/*				[*/}
									{/*					RHAP_UI.CURRENT_TIME,*/}
									{/*					RHAP_UI.PROGRESS_BAR,*/}
									{/*					RHAP_UI.DURATION*/}
									{/*				]*/}
									{/*			}*/}
									{/*			// customControlsSection={[*/}
									{/*			// 	RHAP_UI.ADDITIONAL_CONTROLS,*/}
									{/*			// 	RHAP_UI.MAIN_CONTROLS*/}
									{/*			// ]}*/}
									{/*			customAdditionalControls={[]}*/}
									{/*			// customVolumeControls={[]}*/}
									{/*			autoPlayAfterSrcChange={true}*/}
									{/*		/>*/}
									{/*	) : (*/}
									{/*		<WaveSurferPlayer*/}
									{/*			// container={'body'}*/}
									{/*			height={60}*/}
									{/*			waveColor={theme.palette.secondary.main}*/}
									{/*			progressColor={theme.palette.primary.main}*/}
									{/*			responsive={true}*/}
									{/*			// cursorColor={'transparent'}*/}
									{/*			cursorColor={theme.palette.primary.main}*/}
									{/*			barWidth={2}*/}
									{/*			barGap={2}*/}
									{/*			barRadius={10}*/}
									{/*			fillParent={true}*/}
									{/*			url={stationPlayerAudio}*/}
									{/*			normalize={false}*/}
									{/*			autoplay={false}*/}
									{/*			mediaControls={false}*/}
									{/*			// minPxPerSec={10}*/}
									{/*			autoCenter={true}*/}
									{/*			plugins={[TimelinePlugin.create()]}*/}
									{/*		/>*/}
									{/*	)*/}
									{/*}*/}
								</div>
							</Stack>
							{/*<div className="filters">
							 <div className="px-2 py-2">
							 {filters.map((filter, index) => (
							 <span key={index}
							 className={stationFilter === filter ? 'selected' : ''}
							 onClick={() => setStationFilter(filter)}
							 >
							 <Button>{t(filter)}</Button>
							 </span>
							 ))}
							 </div>
							 </div>*/}
							<>
								<Typography component={'div'} sx={{
									color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
									fontSize: (theme) => theme.typography.fontSize
								}} className="pt-4 mb-3 mt-3 font-bold">{t('radio.play_list')}</Typography>
								{
									Object.keys(stations).length > 0 ?
										(
											<>
												<TabsComponent stations={stations} stationFilterKey={stationFilterKey}
												               handleTabChange={handleTabChange}/>
												{
													Object.keys(stationFilter).length > 0 ? (
														<List className="py-0 flex flex-col mt-2">
															{Object.values(stationFilter).map((station: any, index: number) => {
																return (
																	<ListItem
																		key={index}
																		alignItems="flex-start" onClick={() => clickStation(station)}
																		sx={{
																			borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.grey[700],
																			bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : 'background.paper'
																		}}
																		className={`rounded border mb-2 p-2 ${theme.palette.mode === 'light' ? (stationPlayer?.name === station.name ? 'bg-blue-200' : '') : (stationPlayer?.name === station.name ? 'bg-gray-800' : '')}`}
																	>
																		<ListItemButton alignItems="flex-start" className="p-0">
																			<ListItemAvatar className="flex justify-center items-center self-center pl-2">
																				<img id="bg"
																				     src={`${serverUrl}/media/images/${station?.logo}?${station?.name}`}
																				     className="w-12 h-12 rounded justify-center"
																				     alt={station?.name}
																				/>
																			</ListItemAvatar>
																			<ListItemText
																				primary={station.name ?
																					<div className="w-full flex flex-col justify-center text-center">
																						<Typography component={'div'} sx={{
																							color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
																							fontSize: (theme) => theme.typography.fontSize - 2
																						}}
																						            className="text-sm overflow-hidden whitespace-nowrap overflow-ellipsis">
																							<div
																								className={`flex flex-row items-center justify-center `}>
																								{/*className={`flex flex-row items-center ${stationPlayer?.name === station.name ? 'text-gray-300' : 'text-gray-800'}`}>*/}
																								{station.name}
																							</div>
																						</Typography>
																						<div className="w-full flex flex-row justify-between items-center">
																							{stationPlayer?.name === station.name ? <PauseIcon/> : <PlayIcon/>}
																							{station.tag ?
																								<Typography component={'span'} sx={{
																									color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
																									fontSize: (theme) => theme.typography.fontSize - 2
																								}} className="font-medium text-sm">
																									<div
																										className="w-full flex flex-row justify-end items-center text-center">
																										{
																											station.tag ? (
																												<span
																													className={`text-sm rounded border ml-2 px-1 ${getTag(station.tag)}`}>
																						{t(`radio.${station.tag}`)}
																					</span>
																											) : (
																												<span className={`text-sm rounded ml-2 px-1}`}>---</span>
																											)
																										}
																									</div>
																								</Typography>
																								: <div></div>
																								// <Skeleton className="w-2/5"/>
																							}
																						</div>
																					</div>
																					:
																					<Skeleton className="w-4/5"/>
																				}
																			/>
																		</ListItemButton>
																	</ListItem>
																);
															})}
														</List>
													) : (
														<div className="w-full text-center mt-5">{t('radio.object_empty')}</div>
													)
												}
											</>
										) :
										(
											<>
												<Divider/>
												<div className="w-full text-center mt-5">{t('radio.object_empty')}</div>
											</>
										)
								}
							</>
						</div>
					</div>
				) : (
					<div className="flex flex-row flex-1 w-full h-full justify-center items-center">
						<CircularProgress color={'secondary'}/>
					</div>
				)
			}
		</>
	);
};
export default Radio;
